// extracted by mini-css-extract-plugin
export default {"compRouteMenu":"src-modules-main-components-Layout-RouteMenu-index-module__comp-route-menu__tG7fJ"};